module.exports = __webpack_public_path__ + "static/media/meteringicon01.eede4aa3.png";